
import { CONTANTS } from '~/constants'
export default {
  props: {
    url: {
      type: String,
      default: undefined,
    },
  },

  data () {
    return {
    }
  },

  methods: {
    onFBClick () {
      if (!this.url) { return false }

      const url = `https://www.facebook.com/sharer/sharer.php?app_id=${CONTANTS.FB_APP_ID}&u=${this.url}&display=popup&ref=plugin`
      window.open(url, 'facebook-share-dialog', 'height=320,width=725')
      return false
    },
    onTwitterClick () {
      if (!this.url) { return false }

      const url = `http://twitter.com/share?url=${this.url}`
      window.open(url, 'twitter-share-dialog', 'height=320,width=725')
      return false
    },
    onLinkedInClick () {
      if (!this.url) { return false }

      const url = `http://www.linkedin.com/shareArticle?mini=true&url=${this.url}` // &title=""&summary=""
      window.open(url, 'linkedin-share-dialog', 'height=320,width=725')
      return false
    },
  },
}
